module.exports = __webpack_public_path__ + "img/2026-02_school-of-medicine.192095d0.webp";